import { useState } from 'react';
import tripFolderService from '../../../services/trips/trip-folder.service';

export interface IMoveFolderModel {
  sourceTripId: string;
  sourceDestinationId?: string;
  sourceFolderId: string;
  targetTripId: string;
}

export const useMoveFolder = (
  onSuccess?: () => void,
  onError?: (error: any) => void
) => {
  const [loading, setLoading] = useState(false);

  const moveFolder = async (payload: IMoveFolderModel) => {
    console.log('useMoveFolder - moveFolder called with payload:', payload);
    setLoading(true);
    try {
      await tripFolderService.moveFolder(payload);
      setLoading(false);
      if (onSuccess) onSuccess();
    } catch (error) {
      setLoading(false);
      if (onError) onError(error);
      else console.error('Error moving folder:', error);
    }
  };

  const copyFolder = async (payload: IMoveFolderModel) => {
    console.log('useMoveFolder - copyFolder called with payload:', payload);
    setLoading(true);
    try {
      await tripFolderService.copyFolder(payload);
      setLoading(false);
      if (onSuccess) onSuccess();
    } catch (error) {
      setLoading(false);
      if (onError) onError(error);
      else console.error('Error copying folder:', error);
    }
  };

  return {
    moveFolder,
    copyFolder,
    loading
  };
};
